<input
  #fileUpload
  type="file"
  [attr.multiple]="multiple"
  style="display: none"
  (change)="onFileSelected($event)"
/>

<button
  type="button"
  class="btn btn-sm btn-blue"
  (click)="fileUpload.click()"
>
  <span class="mdi mdi-plus-circle"></span>
  <ng-container *ngIf="multiple">
    Adaugă fișiere
  </ng-container>
  <ng-container *ngIf="!multiple">
    Adaugă fișier
  </ng-container>
</button>
